<script lang="ts">
    import cryptoCats from 'src/components/main/games/components/game-cards/cats.png'
    import cryptoCatsMobile from 'src/components/main/games/components/game-cards/cats-image.svg'
    import cryptoCatsBackground from 'src/components/main/games/components/game-cards/cats-background.jpg'
    import cryptoDragons from 'src/components/main/games/components/game-cards/dragons.png'
    import cryptoDragonsImage from 'src/components/main/games/components/game-cards/dragons-image.svg'
    import cryptoDragonsBackground from 'src/components/main/games/components/game-cards/dragons-background.jpg'
    import cryptoFox from 'src/components/main/games/components/game-cards/foxes.png'
    import cryptoFoxImage from 'src/components/main/games/components/game-cards/foxes-image.svg'
    import cryptoFoxBackground from 'src/components/main/games/components/game-cards/foxes-background.jpg'
    import cryptoDoge from 'src/components/main/games/components/game-cards/doges.png'
    import cryptoDogeImage from 'src/components/main/games/components/game-cards/doges-image.svg'
    import cryptoDogeBackground from 'src/components/main/games/components/game-cards/doges-background.jpg'
    import cryptoPepe from 'src/components/main/games/components/game-cards/pepe.png'
    import cryptoPepeImage from 'src/components/main/games/components/game-cards/pepe-image.png'
    import cryptoPepeBackground from 'src/components/main/games/components/game-cards/pepe-background.jpg'
    import elonGame from 'src/components/main/games/components/game-cards/elon.png'
    import elonGameImage from 'src/components/main/games/components/game-cards/elon-image.png'
    import elonGameBackground from 'src/components/main/games/components/game-cards/elon-background.png'
    import googlePlay from 'src/components/main/#assets/google-play.svg'
    import IconifyIcon from '@iconify/svelte'
    import star from '@iconify/icons-fa-solid/star'
    import starHalfAlt from '@iconify/icons-fa-solid/star-half-alt'
</script>

<section class="game-cards">
    <div class="container">
        <div class="main-intro-games">
            <div class="game-card cats-card" style="--cryptoCatsBackground:url({cryptoCatsBackground})">
                <div class="row">
                    <div class="col-md-7 col-lg-6">
                        <img src="{cryptoCats}" class="image cats-image d-none d-md-block" alt="">
                        <img src="{cryptoCatsMobile}" class="image cats-image d-md-none" alt="">
                    </div>
                    <div class="col-md-5 col-lg-6">
                        <div class="card-content">
                            <div class="title">Crypto Cats</div>
                            <div class="game-rating">
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={starHalfAlt}/>
                            </div>
                            <hr>
                            <div class="description">
                                Crypto Cats - Get crypto by playing. Complete daily quests and get your LIS rewards.<br><br>
                                Collect and merge cute cats, open interesting characters, and get awesome rewards in Crypto Cats. An exciting adventure awaits you!
                            </div>
                            <a href="https://play.google.com/store/apps/details?id=com.soul.merge.cat.cute.simulator.adventure" target="_blank" class="google-play">
                                <img src="{googlePlay}" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="game-card dragons-card" style="--cryptoDragonsBackground:url({cryptoDragonsBackground})">
                <div class="row">
                    <div class="col-md-7 col-lg-6">
                        <img src="{cryptoDragons}" class="image dragons-image d-none d-md-block" alt="">
                        <img src="{cryptoDragonsImage}" class="image dragons-image d-md-none" alt="">
                    </div>
                    <div class="col-md-5 col-lg-6">
                        <div class="card-content">
                            <div class="title">Crypto Dragons</div>
                            <div class="game-rating">
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={starHalfAlt}/>
                            </div>
                            <hr>
                            <div class="description">
                                Crypto Dragons - embark on a world of adventure with the mysterious Crypto Dragons. Simple mechanics and valuable crypto rewards.<br><br>
                                Merge mystical dragons, complete tasks to get game bonuses and LIS Token
                            </div>
                            <a href="https://play.google.com/store/apps/details?id=com.dragons.tokens.crypto" target="_blank" class="google-play">
                                <img src="{googlePlay}" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="game-card foxes-card" style="--cryptoFoxBackground:url({cryptoFoxBackground})">
                <div class="row">
                    <div class="col-md-7 col-lg-6">
                        <img src="{cryptoFox}" class="image foxes-image d-none d-md-block" alt="">
                        <img src="{cryptoFoxImage}" class="image foxes-image d-md-none" alt="">
                    </div>
                    <div class="col-md-5 col-lg-6">
                        <div class="card-content">
                            <div class="title">Crypto Fox</div>
                            <div class="game-rating">
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={starHalfAlt}/>
                            </div>
                            <hr>
                            <div class="description">
                                Crypto Fox is an addictive merge game. Over 100 unique fox species that will bring you valuable rewards.<br><br>
                                Merge cute characters, complete daily tasks and achievements to get LIS token and other valuable bonuses.
                            </div>
                            <a href="https://play.google.com/store/apps/details?id=com.realis.fox.nft.token" target="_blank" class="google-play">
                                <img src="{googlePlay}" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="game-card doges-card" style="--cryptoDogeBackground:url({cryptoDogeBackground})">
                <div class="row">
                    <div class="col-md-7 col-lg-6">
                        <img src="{cryptoDoge}" class="image doges-image d-none d-md-block" alt="">
                        <img src="{cryptoDogeImage}" class="image doges-image d-md-none" alt="">
                    </div>
                    <div class="col-md-5 col-lg-6">
                        <div class="card-content">
                            <div class="title">Crypto DOGE</div>
                            <div class="game-rating">
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={starHalfAlt}/>
                            </div>
                            <hr>
                            <div class="description">
                                Crypto DOGE is the most awaited game for the crypto community. Over 150 awesome DOGEs.<br><br>
                                You'll recognize these characters at first sight. Complete daily quests and get valuable prizes
                            </div>
                            <a href="https://play.google.com/store/apps/details?id=elon.musk.doge.meme.blockchain.coin.twit" target="_blank" class="google-play">
                                <img src="{googlePlay}" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="game-card elon-card" style="--elonGameBackground:url({elonGameBackground})">
                <div class="row">
                    <div class="col-md-7 col-lg-6">
                        <img src="{elonGame}" class="image elon-image d-none d-md-block" alt="">
                        <img src="{elonGameImage}" class="image elon-image d-md-none" alt="">
                    </div>
                    <div class="col-md-5 col-lg-6">
                        <div class="card-content">
                            <div class="title">Elon Game</div>
                            <div class="game-rating">
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={starHalfAlt}/>
                            </div>
                            <hr>
                            <div class="description">
                                Unlock new levels and meet Meme Lord in the most unexpected ways!<br><br>
                                Complete daily quests, upgrade your gaming experience with surprising locations and get valuable crypto rewards!
                            </div>
                            <a href="https://play.google.com/store/apps/details?id=com.realis.elon.nft.token" target="_blank" class="google-play">
                                <img src="{googlePlay}" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="game-card pepe-card" style="--cryptoPepeBackground:url({cryptoPepeBackground})">
                <div class="row">
                    <div class="col-md-7 col-lg-6">
                        <img src="{cryptoPepe}" class="image pepe-image d-none d-md-block" alt="">
                        <img src="{cryptoPepeImage}" class="image pepe-image d-md-none" alt="">
                    </div>
                    <div class="col-md-5 col-lg-6">
                        <div class="card-content">
                            <div class="title">Crypto Frepe</div>
                            <div class="game-rating">
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={star}/>
                                <IconifyIcon class="star-icon" icon={starHalfAlt}/>
                            </div>
                            <hr>
                            <div class="description">
                                Crypto Frepe is the game that will take over the memecoin community. Join this crypto craze.<br><br>
                                Merge, conquer, and dominate the world with your army of hilarious Pepe the Frog warriors.
                            </div>
                            <a href="https://play.google.com/store/apps/details?id=com.frog.meme.token" target="_blank" class="google-play">
                                <img src="{googlePlay}" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .game-cards {
        position: relative;
        padding: 105px 0 0;
        margin: 110px 0 200px;
    }

    .game-card {
        border-radius: 30px;
        border: 1px solid #FF5D1C;
        background: rgba(255, 255, 255, 0.05);
        padding: 50px 110px;
    }

    .game-card:not(:last-child) {
        margin-bottom: 150px;
    }

    .image  {
        margin: -55px 0 -155px -40px;
        transition: .5s;
    }

    .image:hover {
        transform: matrix3d(1,-.03,0,.0004,.03,1,-.05,0,0,.05,1,0,5,0,-20,1) scale(0.95);
    }

    .title {
        color: #FFF;
        font-family: 'Anton', sans-serif;
        font-size: 50px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        letter-spacing: 2px;
        margin-bottom: 10px;
    }

    .game-rating {
        color: #F2C94C;
        font-size: 25px;
    }

    .game-card hr {
        background: white;
        margin: 20px 0 30px;
        opacity: 1;
    }

    .description {
        font-size: 16px;
        font-style: normal;
        line-height: 1.5;
        color: white;
        margin-bottom: 50px;
    }

    .google-play {
        display: table;
        transition: .25s;
    }

    .google-play:hover {
        transform: translateY(-5px);
    }

    @media(max-width: 1400px) {
        .image {
            margin: -40px 0 -155px -40px;
            height: 620px;
        }
    }

    @media(max-width: 1199px) {
        .game-card {
            padding: 30px 50px;
        }

        .game-card:not(:last-child) {
            margin-bottom: 120px;
        }

        .google-play img {
            max-width: 220px;
        }

        .image {
            height: 530px;
        }

        .title {
            font-size: 40px;
        }

        .game-rating {
            font-size: 22px;
        }

        .game-card hr {
            margin: 18px 0 20px;
        }

        .description {
            font-size: 15px;
            margin-bottom: 30px;
        }
    }

    @media(max-width: 991px) {
        .image {
            height: 510px;
            margin: -20px 0 -110px -50px;
        }

        .title {
            font-size: 34px;
        }

        .game-rating {
            font-size: 20px;
        }

        .description {
            font-size: 14px;
            margin-bottom: 20px;
        }
    }

    @media(max-width: 767px) {
        .game-cards {
            margin: 62px 0 200px;
            padding: 85px 0 0;
        }

        .cats-card {
            background: var(--cryptoCatsBackground) no-repeat center;
        }

        .dragons-card {
            background: var(--cryptoDragonsBackground) no-repeat center;
        }

        .foxes-card {
            background: var(--cryptoFoxBackground) no-repeat center;
        }

        .doges-card {
            background: var(--cryptoDogeBackground) no-repeat center;
        }

        .pepe-card {
            background: var(--cryptoPepeBackground) no-repeat center;
        }

        .elon-card {
            background: var(--elonGameBackground) no-repeat center;
        }

        .game-card {
            background-size: cover;
            border: 1px solid #6569c0;
            border-radius: 10px;
            padding: 0 15px 15px;
        }

        .game-card:not(:last-child) {
            margin-bottom: 80px;
        }

        .image {
            max-width: 100%;
            width: 100%;
            height: auto;
        }

        .cats-image {
            margin: -45px auto -130px;
        }

        .dragons-image {
            margin: -45px auto -15px;
        }

        .foxes-image {
            margin: -45px auto -25px;
        }

        .doges-image {
            margin: -60px auto -170px;
        }

        .elon-image {
            margin: -90px auto -140px;
        }

        .pepe-image {
            margin: -50px auto 20px;
        }

        .card-content {
            border-radius: 10px;
            background: linear-gradient(204deg, rgba(91, 93, 140, 0.54) 25.29%, rgba(40, 41, 67, 0.54) 93.02%);
            backdrop-filter: blur(7.5px);
            margin: 0 -15px -15px;
            padding: 15px;
        }

        .image:hover {
            transform: none;
        }

        .title {
            font-size: 30px;
        }

        .description {
            font-size: 15px;
        }

        .google-play:hover {
            transform: none;
        }
    }
</style>
